"use client"

import { useState } from 'react'
import { Button } from '@/components/ui/button'

export default function SampleClassForm() {
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [agree, setAgree] = useState(false)
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setSuccess(null)
    if (!agree) {
      setError('Please agree to receive email updates before submitting.')
      return
    }
    if (!email) {
      setError('Email is required.')
      return
    }
    try {
      setLoading(true)
      const res = await fetch('/api/pricing/sample-class', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, name: name || undefined }),
      })
      const data = await res.json().catch(() => ({}))
      if (!res.ok) {
        setError(data?.error || 'Failed to send sample. Please try again later.')
        return
      }
      setSuccess('Thanks! Please check your email for your class sample.')
      setEmail('')
      setName('')
      setAgree(false)
    } catch (e: any) {
      setError(e?.message || 'Something went wrong. Please try again later.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <form className="flex flex-col sm:flex-row gap-3 items-stretch" onSubmit={onSubmit}>
        <input
          type="email"
          required
          placeholder="Enter Email Address"
          className="flex-1 rounded-md bg-background border border-border px-4 py-3"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button type="submit" className="whitespace-nowrap" disabled={!agree || loading}>
          {loading ? 'Sending…' : 'Submit'}
        </Button>
      </form>
      <div className="mt-3 text-xs text-muted-foreground">
        <label className="inline-flex items-start gap-2">
          <input type="checkbox" className="mt-0.5" checked={agree} onChange={(e) => setAgree(e.target.checked)} />
          <span>I agree to receive email updates on D.R.I.V.E. products.</span>
        </label>
        <p className="mt-1">
          By clicking "Submit" and sharing your email, you agree to our Terms of Service and Privacy Policy.
        </p>
        {error && <p className="text-red-600 mt-1">{error}</p>}
        {success && <p className="text-green-600 mt-1">{success}</p>}
      </div>
    </div>
  )
}
